<div
  class="button-wrapper"
  [ngbTooltip]="'common.delete_action' | cxTranslate"
  [placement]="'bottom'"
  [disableTooltip]="isSection"
>
  <button
    *ngIf="!isSection"
    #popOver="ngbPopover"
    class="btn btn-icon btn-ternary"
    container="body"
    [attr.aria-label]="'common.delete_action' | cxTranslate"
    [ngbPopover]="popContent"
    [popoverClass]="'delete-area-of-use-category-popover'"
    [autoClose]="'outside'"
    [placement]="placement"
    [disabled]="disabled"
  >
    <i nz-icon nzType="delete"></i>
  </button>

  <py-action-button
    *ngIf="isSection"
    #popOver="ngbPopover"
    class="d-block"
    container="body"
    [attr.aria-label]="'common.delete_action' | cxTranslate"
    [ngbPopover]="popContent"
    [popoverClass]="'delete-area-of-use-category-popover'"
    [autoClose]="'outside'"
    [placement]="placement"
    [buttonClass]="'btn btn-ternary text-danger d-flex align-items-center justify-content-center'"
    [buttonLabel]="'areaOfUse.deleteSection_action' | cxTranslate"
    [disabled]="disabled"
  >
    <i nz-icon nzType="delete"></i>
  </py-action-button>
</div>

<ng-template #popContent>
  <div class="header d-flex align-items-center justify-content-between p-3">
    <h1>
      <ng-container *ngIf="isSection; then deleteSectionTitleText; else deleteCategoryTitleText"></ng-container>
    </h1>
    <button type="button" class="close" [attr.aria-label]="'common.close_action' | cxTranslate" (click)="closePopover()">
      <i nz-icon pyIconThemeReverse nzType="close-circle" nzTheme="outline"></i>
    </button>
  </div>

  <div class="p-3">
    <p>
      <ng-container *ngIf="isSection; then deleteSectionContentText; else deleteCategoryContentText"></ng-container>
    </p>
    <button pyPreventDoubleClick type="button" class="btn btn-ternary mt-2 button-action" autofocus (click)="closePopover()">
      {{ 'common.noAndCancel_action' | cxTranslate }}
    </button>
    <button pyPreventDoubleClick type="button" class="btn btn-danger mt-3 button-action" autofocus (click)="delete()">
      {{ 'common.yesAndDelete_action' | cxTranslate }}
    </button>
  </div>
</ng-template>

<ng-template #deleteSectionTitleText>
  {{ 'areaOfUse.deleteSection_title' | cxTranslate }}
</ng-template>

<ng-template #deleteCategoryTitleText>
  {{ 'areaOfUse.deleteCategory_title' | cxTranslate }}
</ng-template>

<ng-template #deleteSectionContentText>
  {{ 'areaOfUse.deleteSection_text' | cxTranslate : { name: areaOfUseCategory?.name } }}
</ng-template>

<ng-template #deleteCategoryContentText>
  {{ 'areaOfUse.deleteCategory_text' | cxTranslate : { name: areaOfUseCategory?.name } }}
</ng-template>
